<template>
  <v-layout style="width: 100%; height: 100%;">
    <div v-show="activePanel == 'dataentry'" style="display: contents">
      <slot name="dataentry"></slot>
    </div>
    <div v-show="activePanel == 'chat'" style="display: contents">
      <slot name="chat"></slot>
    </div>
    <div v-show="activePanel == 'graph'" style="display: contents">
      <slot name="graph"></slot>
    </div>
    <MobileNavigation v-model="activePanel" :show-blurry-background="activePanel != 'chat'" />
  </v-layout>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import MobileNavigation from './MobileNavigation.vue';

const activePanel = ref<"dataentry" | "chat" | "graph">("dataentry")
</script>